import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import "regenerator-runtime/runtime.js";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.find.js";
import "core-js/modules/es.array.find-index.js";
import "core-js/modules/es.array.from.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.array.splice.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.set.js";
import "core-js/modules/es.string.includes.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/es.string.starts-with.js";
import "core-js/modules/es.string.trim.js";
import "core-js/modules/esnext.set.add-all.js";
import "core-js/modules/esnext.set.delete-all.js";
import "core-js/modules/esnext.set.difference.js";
import "core-js/modules/esnext.set.every.js";
import "core-js/modules/esnext.set.filter.js";
import "core-js/modules/esnext.set.find.js";
import "core-js/modules/esnext.set.intersection.js";
import "core-js/modules/esnext.set.is-disjoint-from.js";
import "core-js/modules/esnext.set.is-subset-of.js";
import "core-js/modules/esnext.set.is-superset-of.js";
import "core-js/modules/esnext.set.join.js";
import "core-js/modules/esnext.set.map.js";
import "core-js/modules/esnext.set.reduce.js";
import "core-js/modules/esnext.set.some.js";
import "core-js/modules/esnext.set.symmetric-difference.js";
import "core-js/modules/esnext.set.union.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/web.dom-collections.iterator.js";
import { defineComponent as _defineComponent } from 'vue';
import { replaceCommaAndParseFloatOrNull } from '~/assets/helper/functions';
import { MetricReportingPeriodType, MetricValueKind, useUpsertMetricValuesMutation } from '~/types/types';
export default /*#__PURE__*/_defineComponent({
  __name: 'MetricValuesDialog',
  props: {
    value: {
      type: Boolean,
      required: true
    },
    // dialog value
    metricAssignment: {
      type: Object,
      required: true
    },
    parentMetricAssignment: {
      type: Object,
      required: false,
      default: null
    },
    period: {
      type: String,
      required: true
    }
  },
  emits: ['input', 'cancel', 'metric-assignment-updated', 'metric-values-created', 'metric-values-created-child', 'metric-assignment-updated-child', 'open:by-metric-id'],
  setup: function setup(__props, _ref) {
    var emit = _ref.emit;
    var props = __props;
    var metric = computed(function () {
      var _props$metricAssignme;
      return ((_props$metricAssignme = props.metricAssignment) === null || _props$metricAssignme === void 0 ? void 0 : _props$metricAssignme.metric) || {};
    });
    var unitName = computed(function () {
      var _metric$value;
      return ((_metric$value = metric.value) === null || _metric$value === void 0 ? void 0 : _metric$value.unitName) || '';
    });
    var reportingPeriodType = computed(function () {
      var _metric$value2, _props$metricAssignme2;
      // Special case for Value of Investment (ID 395) - always quarterly
      if (((_metric$value2 = metric.value) === null || _metric$value2 === void 0 ? void 0 : _metric$value2.id) === 395) {
        return MetricReportingPeriodType.Quarterly;
      }
      return (_props$metricAssignme2 = props.metricAssignment) === null || _props$metricAssignme2 === void 0 ? void 0 : _props$metricAssignme2.reportingPeriodType;
    });
    var metricValue = computed(function () {
      var _props$metricAssignme3, _props$metricAssignme4, _props$metricAssignme5;
      var found = (_props$metricAssignme3 = props.metricAssignment) === null || _props$metricAssignme3 === void 0 ? void 0 : (_props$metricAssignme4 = _props$metricAssignme3.metricValues) === null || _props$metricAssignme4 === void 0 ? void 0 : _props$metricAssignme4.find(function (e) {
        return e.period === props.period;
      });
      if (found) return found;
      return {
        period: props.period,
        metricAssignmentId: (_props$metricAssignme5 = props.metricAssignment) === null || _props$metricAssignme5 === void 0 ? void 0 : _props$metricAssignme5.id,
        actual: undefined,
        target: undefined,
        text: undefined,
        options: undefined,
        skipped: false,
        comment: undefined,
        editable: true,
        id: undefined,
        isConditionMet: true,
        type: undefined
      };
    });
    var clearTargets = ref(false);
    var localShowTarget = ref(false);
    var showTarget = computed(function () {
      if (localShowTarget.value) {
        return localShowTarget.value;
      }
      if (reportingPeriodType.value === MetricReportingPeriodType.Annual) {
        if (!localShowTarget.value) {
          var _metricValue$value, _metricValue$value2;
          return ((_metricValue$value = metricValue.value) === null || _metricValue$value === void 0 ? void 0 : _metricValue$value.target) !== null && ((_metricValue$value2 = metricValue.value) === null || _metricValue$value2 === void 0 ? void 0 : _metricValue$value2.target) !== undefined;
        }
      } else {
        return metricValues.value.some(function (e) {
          return e.target !== null && e.target !== undefined;
        });
      }
      return false;
    });
    var metricValues = computed(function () {
      var _props$metricAssignme6;
      return (((_props$metricAssignme6 = props.metricAssignment) === null || _props$metricAssignme6 === void 0 ? void 0 : _props$metricAssignme6.metricValues) || []).filter(function (v) {
        return v.period.includes(props.period);
      }) || [];
    });
    var inputs = ref([]);
    var effectiveMetricValueForConditions = computed(function () {
      var pendingInput = inputs.value.find(function (i) {
        return i.metricAssignmentId === metricValue.value.metricAssignmentId && i.period === metricValue.value.period;
      });
      if (!pendingInput) {
        return metricValue.value;
      }
      return _objectSpread(_objectSpread({}, metricValue.value), pendingInput);
    });
    var input = function input(val) {
      if (val.text === '') {
        // Ensures an empty string is not considered an "answer"
        val.text = null;
      }
      // When ever user make a change, we store it in the local state
      var index = inputs.value.findIndex(function (i) {
        return i.metricAssignmentId === val.metricAssignmentId && i.period === val.period;
      });
      var toAdd;
      if (index > -1) {
        toAdd = _objectSpread(_objectSpread({}, inputs.value[index]), val);
        inputs.value.splice(index, 1); // remove the obj the value
      } else {
        toAdd = val;
      }
      inputs.value.push(toAdd);
    };
    var _useUpsertMetricValue = useUpsertMetricValuesMutation(),
      mutate = _useUpsertMetricValue.mutate,
      loading = _useUpsertMetricValue.loading;
    onMounted(/*#__PURE__*/_asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee() {
      var _props$period, _props$metricAssignme7, _props$metricAssignme8;
      var year, existingPeriods, toAdd, q, quarterPeriod, m, monthPeriod, _result$data, result, _props$parentMetricAs;
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            year = String((_props$period = props.period) !== null && _props$period !== void 0 ? _props$period : '').trim();
            existingPeriods = new Set(((_props$metricAssignme7 = props.metricAssignment) === null || _props$metricAssignme7 === void 0 ? void 0 : (_props$metricAssignme8 = _props$metricAssignme7.metricValues) === null || _props$metricAssignme8 === void 0 ? void 0 : _props$metricAssignme8.map(function (mv) {
              return mv.period;
            })) || []);
            toAdd = [];
            if (!(reportingPeriodType.value === MetricReportingPeriodType.Quarterly)) {
              _context.next = 9;
              break;
            }
            if (year) {
              _context.next = 6;
              break;
            }
            return _context.abrupt("return");
          case 6:
            // Check for missing quarters
            for (q = 1; q <= 4; q++) {
              quarterPeriod = "".concat(year, " Q").concat(q);
              if (!existingPeriods.has(quarterPeriod)) {
                toAdd.push({
                  period: quarterPeriod,
                  metricAssignmentId: props.metricAssignment.id,
                  actual: undefined,
                  target: undefined,
                  text: undefined,
                  options: undefined,
                  skipped: false,
                  comment: undefined
                });
              }
            }
            _context.next = 19;
            break;
          case 9:
            if (!(reportingPeriodType.value === MetricReportingPeriodType.Monthly)) {
              _context.next = 15;
              break;
            }
            if (year) {
              _context.next = 12;
              break;
            }
            return _context.abrupt("return");
          case 12:
            // Check for missing months
            for (m = 1; m <= 12; m++) {
              monthPeriod = "".concat(year, " M").concat(m);
              if (!existingPeriods.has(monthPeriod)) {
                toAdd.push({
                  period: monthPeriod,
                  metricAssignmentId: props.metricAssignment.id,
                  actual: undefined,
                  target: undefined,
                  text: undefined,
                  options: undefined,
                  skipped: false,
                  comment: undefined
                });
              }
            }
            _context.next = 19;
            break;
          case 15:
            if (metricValue.value.id) {
              _context.next = 19;
              break;
            }
            if (year) {
              _context.next = 18;
              break;
            }
            return _context.abrupt("return");
          case 18:
            // For annual metrics, just create one value if it doesn't exist
            toAdd.push({
              period: year,
              metricAssignmentId: props.metricAssignment.id,
              actual: undefined,
              target: undefined,
              text: undefined,
              options: undefined,
              skipped: false,
              comment: undefined
            });
          case 19:
            if (!(toAdd.length > 0)) {
              _context.next = 24;
              break;
            }
            _context.next = 22;
            return mutate({
              inputs: toAdd
            });
          case 22:
            result = _context.sent;
            if (result !== null && result !== void 0 && (_result$data = result.data) !== null && _result$data !== void 0 && _result$data.upsertMetricValues) {
              // Emit child event if we have a parent, otherwise emit parent event
              emit('metric-values-created', props !== null && props !== void 0 && (_props$parentMetricAs = props.parentMetricAssignment) !== null && _props$parentMetricAs !== void 0 && _props$parentMetricAs.id ? props.parentMetricAssignment.id : props.metricAssignment.id);
            }
          case 24:
          case "end":
            return _context.stop();
        }
      }, _callee);
    })));
    var update = function update() {
      var normalizedInputs = inputs.value.map(function (i) {
        var _metric$value3, _metric$value4;
        var normalized = _objectSpread({}, i);
        if (Object.prototype.hasOwnProperty.call(normalized, 'actual') && [MetricValueKind.Int, MetricValueKind.Float].includes((_metric$value3 = metric.value) === null || _metric$value3 === void 0 ? void 0 : _metric$value3.valueType) && normalized.actual !== null && normalized.actual !== undefined) {
          normalized.actual = replaceCommaAndParseFloatOrNull(String(normalized.actual));
        }
        if (Object.prototype.hasOwnProperty.call(normalized, 'target') && [MetricValueKind.Int, MetricValueKind.Float].includes((_metric$value4 = metric.value) === null || _metric$value4 === void 0 ? void 0 : _metric$value4.valueType) && normalized.target !== null && normalized.target !== undefined) {
          normalized.target = replaceCommaAndParseFloatOrNull(String(normalized.target));
        }
        return normalized;
      });
      mutate({
        inputs: normalizedInputs
      }).then(function (result) {
        var _result$data2;
        if (result !== null && result !== void 0 && (_result$data2 = result.data) !== null && _result$data2 !== void 0 && _result$data2.upsertMetricValues) {
          var _props$parentMetricAs2;
          // Emit child event if we have a parent, otherwise emit parent event
          emit('metric-assignment-updated', {
            id: props !== null && props !== void 0 && (_props$parentMetricAs2 = props.parentMetricAssignment) !== null && _props$parentMetricAs2 !== void 0 && _props$parentMetricAs2.id ? props.parentMetricAssignment.id : props.metricAssignment.id,
            updatedValues: normalizedInputs
          });
          window.$nuxt.$emit('userMsg');
          resetAndCloseDialog();
        }
      });
    };
    var skipped = computed(function () {
      return metricValue.value.skipped;
    });
    var localSkipped = ref(skipped.value);
    watch(skipped, function (v) {
      localSkipped.value = v;
    });
    var disabled = computed(function () {
      if (inputs.value.length === 0) return true;
      if (inputs.value.some(function (input) {
        return input.skipped === true;
      })) {
        var commentFromInputs = inputs.value.find(function (item) {
          return item.comment;
        });
        var commentString = commentFromInputs ? commentFromInputs.comment : metricValue.value.comment;
        return !commentString;
      }
      return false;
    });
    var resetAndCloseDialog = function resetAndCloseDialog() {
      inputs.value = []; // clear pending inputs
      localShowTarget.value = false;
      clearTargets.value = false;
      emit('cancel');
    };
    var toggleSkipped = function toggleSkipped(doSkip) {
      localSkipped.value = doSkip;
      var val = {
        metricAssignmentId: metricValue.value.metricAssignmentId,
        skipped: doSkip
      };
      if (doSkip) {
        var toClear = {
          actual: null,
          text: null,
          options: null
        };
        val = _objectSpread(_objectSpread({}, val), toClear);
      }
      var periods = [];
      if (reportingPeriodType.value === MetricReportingPeriodType.Quarterly) {
        periods = Array.from({
          length: 4
        }, function (_, idx) {
          return "".concat(props.period, " Q").concat(idx + 1);
        });
      } else if (reportingPeriodType.value === MetricReportingPeriodType.Monthly) {
        periods = Array.from({
          length: 12
        }, function (_, idx) {
          return "".concat(props.period, " M").concat(idx + 1);
        });
      } else if (metricValue.value.period) {
        periods = [metricValue.value.period];
      } else {
        periods = [props.period];
      }
      periods.forEach(function (period) {
        input(_objectSpread(_objectSpread({}, val), {}, {
          period: period
        }));
      });
    };
    var handleShowTarget = function handleShowTarget(doShow) {
      localShowTarget.value = doShow;
      if (doShow === false) {
        clearTargets.value = true;
        if (reportingPeriodType.value === MetricReportingPeriodType.Quarterly) {
          // Clear targets for all quarters
          for (var q = 1; q <= 4; q++) {
            var quarterPeriod = "".concat(props.period, " Q").concat(q);
            var val = {
              metricAssignmentId: props.metricAssignment.id,
              period: quarterPeriod,
              target: null
            };
            input(val);
          }
        } else if (reportingPeriodType.value === MetricReportingPeriodType.Monthly) {
          // Clear targets for all months
          for (var m = 1; m <= 12; m++) {
            var monthPeriod = "".concat(props.period, " M").concat(m);
            var _val = {
              metricAssignmentId: props.metricAssignment.id,
              period: monthPeriod,
              target: null
            };
            input(_val);
          }
        } else {
          // For annual metrics, just clear the single target
          var _val2 = {
            metricAssignmentId: metricValue.value.metricAssignmentId,
            period: metricValue.value.period,
            target: null
          };
          input(_val2);
        }
      }
    };
    var scrolled = ref(false);
    var onScroll = function onScroll(evt) {
      if (evt.target.scrollTop <= 0 && scrolled.value) {
        scrolled.value = false;
      } else if (evt.target.scrollTop > 0 && !scrolled.value) {
        scrolled.value = true;
      }
    };
    var isOnlyLastQuarterForValueOfInvestmentFilled = computed(function () {
      // Early return if metric is not "Value of investment"
      if ((metric === null || metric === void 0 ? void 0 : metric.id) !== 395) return false;

      // Initialize an object to track actual values by quarter
      var quarterValues = {};
      metricValues.value.filter(function (e) {
        var _e$period;
        return (_e$period = e.period) === null || _e$period === void 0 ? void 0 : _e$period.includes('Q');
      }).forEach(function (e) {
        var quarterNumber = e.period.slice(-1);
        quarterValues[quarterNumber] = e.actual;
      });

      // Update quarterValues based on inputs
      inputs.value.forEach(function (item) {
        var _item$period$slice, _item$period, _item$actual;
        var quarterNumber = (_item$period$slice = (_item$period = item.period) === null || _item$period === void 0 ? void 0 : _item$period.slice(-1)) !== null && _item$period$slice !== void 0 ? _item$period$slice : '';
        quarterValues[quarterNumber] = (_item$actual = item === null || item === void 0 ? void 0 : item.actual) !== null && _item$actual !== void 0 ? _item$actual : null;
      });

      // Check that the first three quarters are empty (null or 0) and the fourth quarter is filled (non-null, non-zero)
      return !quarterValues['1'] && !quarterValues['2'] && !quarterValues['3'] && !!quarterValues['4'];
    });
    var dialogWidth = computed(function () {
      if (!reportingPeriodType.value) return 650;
      return reportingPeriodType.value !== MetricReportingPeriodType.Annual ? 1000 : 650;
    });
    var missingQuarterlyValues = computed(function () {
      var _metricValue$value$pe, _metricValue$value3, _metricValue$value3$p;
      // If a metric was filled in with an annual value
      // Then the portoflio swicthed to quarterly
      // We want to show WHY the KPI has no data.

      if (reportingPeriodType.value !== MetricReportingPeriodType.Quarterly) {
        return false;
      }
      var hasAnnualValue = metricValue.value.actual || metricValue.value.target || metricValue.value.options && metricValue.value.options.length > 0 || metricValue.value.text;
      if (!hasAnnualValue) {
        return false;
      }
      var year = (_metricValue$value$pe = metricValue === null || metricValue === void 0 ? void 0 : (_metricValue$value3 = metricValue.value) === null || _metricValue$value3 === void 0 ? void 0 : (_metricValue$value3$p = _metricValue$value3.period) === null || _metricValue$value3$p === void 0 ? void 0 : _metricValue$value3$p.split(' ')[0]) !== null && _metricValue$value$pe !== void 0 ? _metricValue$value$pe : '';

      // Filter out the annual value and only keep quarterly values
      var quarterlyMetricValues = metricValues.value.filter(function (mv) {
        return mv.period !== year && mv.period.includes('Q');
      });
      var hasQuarterlyValues = quarterlyMetricValues.some(function (mv) {
        return mv.period.startsWith(year) && (mv.actual || mv.target || mv.options && mv.options.length > 0 || mv.text);
      });
      return !hasQuarterlyValues;
    });
    return {
      __sfc: true,
      props: props,
      emit: emit,
      metric: metric,
      unitName: unitName,
      reportingPeriodType: reportingPeriodType,
      metricValue: metricValue,
      clearTargets: clearTargets,
      localShowTarget: localShowTarget,
      showTarget: showTarget,
      metricValues: metricValues,
      inputs: inputs,
      effectiveMetricValueForConditions: effectiveMetricValueForConditions,
      input: input,
      mutate: mutate,
      loading: loading,
      update: update,
      skipped: skipped,
      localSkipped: localSkipped,
      disabled: disabled,
      resetAndCloseDialog: resetAndCloseDialog,
      toggleSkipped: toggleSkipped,
      handleShowTarget: handleShowTarget,
      scrolled: scrolled,
      onScroll: onScroll,
      isOnlyLastQuarterForValueOfInvestmentFilled: isOnlyLastQuarterForValueOfInvestmentFilled,
      dialogWidth: dialogWidth,
      missingQuarterlyValues: missingQuarterlyValues,
      MetricReportingPeriodType: MetricReportingPeriodType,
      MetricValueKind: MetricValueKind
    };
  }
});